import React from 'react';
import type { FavoriteItemsType, RecentItemsType } from './types.tsx';
import { RenderRecentSection } from './recent-section/index.tsx';
import { RenderStarredSection } from './starred-section/index.tsx';
import { RenderMostRecentProjectSection } from './most-recent-project-section/index.tsx';

export const Nav4ProjectsSections = ({
	favoriteItems,
	recentItems,
	mostRecentProjectItem,
}: {
	favoriteItems: FavoriteItemsType;
	recentItems: RecentItemsType;
	mostRecentProjectItem: React.JSX.Element | null;
}) => (
	<>
		<RenderStarredSection favoriteItems={favoriteItems} />
		<RenderRecentSection recentItems={recentItems} />
		<RenderMostRecentProjectSection projectItem={mostRecentProjectItem} />
	</>
);
